import biLogger from '@wix/web-bi-logger';
import { Logger } from '@wix/web-bi-logger/dist/src/types';

export const hfBiConfig = {
  endpoint: 'hp',
  oldEndpoint: 'hf',
  src: '19',
  languageChange: '313',
  headerActions: '349',
  headerLoaded: '514',
};

export const MOBILE_MAX_WIDTH = 1024;

export type Action = 'hover' | 'click' | 'open_tab' | 'close_tab';

export interface BiParams {
  evid?: string;
  version?: string;
  button_name?: string;
  hover_ms?: number;
  action: Action;
  from: string;
  to?: string;
  tab?: string;
  sub_tab?: string;
}

export const wrapLinkWithBiEvent = (
  logger: Logger,
  link: HTMLAnchorElement,
  elementForListener: HTMLElement,
  extendParams: (link: HTMLAnchorElement) => BiParams,
) => {
  const listener = (event: Event) => {
    event.preventDefault();
    const params: Partial<BiParams> = {
      evid: hfBiConfig.headerActions,
      action: 'click',
    };

    if (extendParams) {
      Object.assign(params, extendParams(link));
    }

    const referencedWindow = link.target === '_blank' ? window.open() : window;
    logger.log(params).then(() => {
      if (link.href && link.getAttribute('role') !== 'button') {
        referencedWindow && referencedWindow.location.assign(link.href);
      }
    });
  };
  elementForListener.addEventListener('click', listener);
  elementForListener.addEventListener('tap', listener);
};

export const wrapLangLinkWithBiEvent = (logger: Logger, link: HTMLAnchorElement, destination_lng: string) => {
  const listener = (event: Event) => {
    event.preventDefault();
    const params = {
      evid: hfBiConfig.languageChange,
      origin: window.location.href,
      origin_lng: 'en',
      destination_lng,
      version: window.WIX_HF_VERSION,
    };

    const referencedWindow = link.target === '_blank' ? window.open() : window;
    logger.log(params).then(() => {
      if (link.href) {
        referencedWindow && referencedWindow.location.assign(link.href);
      }
    });
  };
  link.addEventListener('click', listener);
  link.addEventListener('tap', listener);
};

export const headerAndFooterBiLogger = biLogger.factory({ endpoint: hfBiConfig.endpoint }).updateDefaults({ src: hfBiConfig.src }).logger();

export const headerAndFooterOldBiLogger = biLogger
  .factory({ endpoint: hfBiConfig.oldEndpoint })
  .updateDefaults({ src: hfBiConfig.src })
  .logger();

export const logHeaderLoaded = () => {
  const load_time = new Date().getTime() - window.WIX_HF_START_TIME;
  headerAndFooterOldBiLogger.log({
    evid: hfBiConfig.headerLoaded,
    component: 'header',
    is_mobile: window.innerWidth <= MOBILE_MAX_WIDTH,
    load_time,
    origin: window.location.href,
  });
};
